import {
  EncounterDischargeReasonCode,
  EncounterInvalidateReasonCode,
} from '@quromedical/fhir-common';
import {
  AdmissionCreateResponse,
  AdmissionGetAllResponse,
  AdmissionGetParams,
  AdmissionUpdateRequest,
  AdmissionUpdateResponse,
  CreateAdmissionSchemaWithPatientInput,
} from '@quromedical/models';
import { trpc } from 'trpc';

export const admissionSWRKey = 'trpc/admission';

export class AdmissionApi {
  public async updateAdmission(params: AdmissionUpdateRequest): Promise<AdmissionUpdateResponse> {
    const result = await trpc.client.admission.update.mutate(params);

    return result;
  }

  public getAdmissions = async (params: AdmissionGetParams): Promise<AdmissionGetAllResponse> => {
    return await trpc.client.admission.getAll.query({
      ...params,
    });
  };

  public async dischargePatient(
    patientId: string,
    reason: EncounterDischargeReasonCode,
    periodEnd: string
  ): Promise<void> {
    await trpc.client.admission.discharge.mutate({
      id: patientId,
      statusReason: reason,
      periodEnd,
    });
  }

  public async invalidateAdmission(
    patientId: string,
    reason: EncounterInvalidateReasonCode
  ): Promise<void> {
    await trpc.client.admission.invalidate.mutate({ id: patientId, statusReason: reason });
  }

  public async createAdmission(
    params: CreateAdmissionSchemaWithPatientInput
  ): Promise<AdmissionCreateResponse> {
    const result = await trpc.client.admission.create.mutate(params);

    return result;
  }
}
